import * as moment from 'moment';

export class ShortDateTimeValueConverter {
    toView(value) {
        if (value) {
            const m = moment(value);
            if (m.isValid()) {
                return m.format('M/D/YYYY h:mm a');
            }
            return "";
        }
    }
}